<template>
  <div class="layout">
    <aside class="sidebar">
      <div class="brand" @click="$router.push('/dashboard')">商城后台</div>
      <router-link class="nav-link" to="/dashboard">工作台</router-link>
      <router-link class="nav-link" to="/categories">分类管理</router-link>
      <router-link class="nav-link" to="/banners">轮播图管理</router-link>
      <router-link class="nav-link" to="/home-navs">首页入口管理</router-link>
      <router-link class="nav-link" to="/products">商品管理</router-link>
      <router-link class="nav-link" to="/point-mall/products">积分商品</router-link>
      <router-link class="nav-link" to="/point-mall/orders">积分订单</router-link>
      <router-link class="nav-link" to="/group-buy">团购活动</router-link>
      <router-link class="nav-link" to="/group-buy/refunds">退款记录</router-link>
      <router-link class="nav-link" to="/orders">普通订单</router-link>
      <router-link class="nav-link" to="/order-config">订单配置</router-link>
      <router-link class="nav-link" to="/share-reward/config">分享奖励配置</router-link>
      <router-link class="nav-link" to="/share-reward/records">分享奖励记录</router-link>
      <router-link class="nav-link" to="/profile-style">我的页面设置</router-link>
      <router-link class="nav-link" to="/pickup-stores">自提点管理</router-link>
      <router-link class="nav-link" to="/store-config">店铺设置</router-link>
    </aside>
    <div class="main">
      <header class="topbar">
        <div>
          <div class="topbar__name">{{ adminName }}</div>
          <el-breadcrumb separator="/" class="topbar__breadcrumb">
            <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="index">
              {{ item }}
            </el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="topbar__actions">
          <el-button type="text" @click="$router.push('/change-password')">修改密码</el-button>
          <el-button type="text" @click="logout">退出登录</el-button>
        </div>
      </header>
      <main class="content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import { clearAdminAuth, getAdminUser } from '../utils/auth'

export default {
  computed: {
    adminName() {
      const admin = getAdminUser()
      return (admin && (admin.realName || admin.username)) || '管理员'
    },
    breadcrumbs() {
      const map = {
        '/dashboard': ['工作台'],
        '/change-password': ['账号安全', '修改密码'],
        '/categories': ['分类管理'],
        '/banners': ['轮播图管理'],
        '/home-navs': ['首页入口管理'],
        '/products': ['商品管理'],
        '/orders': ['普通订单'],
        '/order-config': ['订单配置'],
        '/group-buy': ['团购活动'],
        '/group-buy/records': ['团购活动', '拼团记录'],
        '/group-buy/refunds': ['团购活动', '退款记录'],
        '/profile-style': ['我的页面设置'],
        '/pickup-stores': ['自提点管理'],
        '/store-config': ['店铺设置'],
        '/share-reward/config': ['分享奖励', '配置'],
        '/share-reward/records': ['分享奖励', '奖励记录'],
        '/point-mall/products': ['积分商城', '积分商品'],
        '/point-mall/products/create': ['积分商城', '积分商品', '新增商品'],
        '/point-mall/orders': ['积分商城', '积分订单'],
        '/404': ['页面不存在']
      }
      if (map[this.$route.path]) {
        return map[this.$route.path]
      }
      if (this.$route.path.startsWith('/products/')) {
        return ['商品管理', '编辑商品']
      }
      if (this.$route.path.startsWith('/orders/')) {
        return ['普通订单', '订单详情']
      }
      if (this.$route.path.startsWith('/point-mall/products/')) {
        return ['积分商城', '积分商品', '编辑商品']
      }
      if (this.$route.path.startsWith('/point-mall/orders/')) {
        return ['积分商城', '积分订单', '订单详情']
      }
      return ['后台']
    }
  },
  methods: {
    logout() {
      clearAdminAuth()
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.layout { display: flex; min-width: 0; height: 100vh; overflow: hidden; }
.sidebar { flex: 0 0 220px; width: 220px; height: 100vh; box-sizing: border-box; overflow-x: hidden; overflow-y: auto; padding: 24px 18px; background: linear-gradient(180deg, #2f2416, #52361e); color: #fff7ee; }
.sidebar { scrollbar-width: thin; scrollbar-color: rgba(255, 247, 238, 0.22) transparent; }
.sidebar::-webkit-scrollbar { width: 6px; }
.sidebar::-webkit-scrollbar-track { background: transparent; }
.sidebar::-webkit-scrollbar-thumb { border-radius: 999px; background: rgba(255, 247, 238, 0.22); }
.sidebar::-webkit-scrollbar-thumb:hover { background: rgba(255, 247, 238, 0.34); }
.brand { margin-bottom: 24px; font-size: 24px; font-weight: 700; cursor: pointer; }
.nav-link { display: block; overflow: hidden; margin-bottom: 10px; padding: 12px 14px; border-radius: 12px; color: rgba(255, 247, 238, 0.88); text-overflow: ellipsis; white-space: nowrap; }
.nav-link.router-link-exact-active { background: rgba(255, 255, 255, 0.12); color: #fff; }
.main { display: flex; flex: 1 1 auto; min-width: 0; height: 100vh; flex-direction: column; overflow: hidden; }
.topbar { display: flex; justify-content: space-between; align-items: center; height: 64px; padding: 0 24px; background: #fff; border-bottom: 1px solid #ebeef5; }
.topbar__actions { display: flex; align-items: center; gap: 8px; }
.topbar__name { font-weight: 600; }
.topbar__breadcrumb { margin-top: 6px; }
.content { flex: 1; min-width: 0; overflow: auto; padding: 24px; }
</style>
